<div class="user-panel flex flex_column">
  <div class="flex gap-12 flex_align-center">
    @if (dataLoading) {
      <yrx-skeleton [styles]="{width: '40px', height: '40px', borderRadius: '6px'}" theme="dark"></yrx-skeleton>
    } @else {
      <img routerLink="/platform/profile/home" [src]="userStore?.userInfoRef?.avatarUrl ?? 'assets/content/header/default-avatar.png'" [alt]="'Аватар игрока '+$safeNavigationMigration(userStore?.login)+' yurelax'" class="avatar cursor-pointer">
    }
    <div class="flex flex_column">
      <p class="text text_big medium c-gradation-100">{{userStore?.login}}</p>
      <p class="text text_table regular" [class.c-gradation-300]="!userStore?.userInfoRef?.isOnline" [class.c-green-300]="userStore?.userInfoRef?.isOnline">{{lastOnlineStatus}}</p>
    </div>
  </div>
  <yrx-spacing type="XS"></yrx-spacing>
  <div class="flex flex_align-center flex_justify-between">
    <p class="text text_table regular c-gradation-300">Баланс игрока:</p>
    <div class="flex flex_justify-between flex_align-center gap-6">
      <p class="headline c-gradation-100">{{userStore?.userInfoRef?.ucoins}}</p>
      <yrx-icon icon="ucoin"></yrx-icon>
    </div>
  </div>
  <yrx-spacing type="XS"></yrx-spacing>
  <yrx-button (press)="openModal()" size="small">Пополнить баланс</yrx-button>
</div>
